<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  variant: {
    type: String,
    default: 'primary',
  },
  noTextShadow: {
    type: Boolean,
    default: false,
  },
  noBoxShadow: {
    type: Boolean,
    default: false,
  },
});

const variantClass = computed(() => `info-label--${props.variant}`);
</script>

<template>
  <span
    :class="[
      'info-label',
      variantClass,
      { 'info-label--no-box-shadow': noBoxShadow },
      { 'info-label--no-text-shadow': noTextShadow }
    ]"
  >
    {{ label }}
  </span>
</template>

<style scoped lang="scss">
.info-label {
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.35);

  &--primary {
    color: #fff;
    background-color: var(--primary);
  }

  &--no-text-shadow {
    text-shadow: none;
  }

  &--no-box-shadow {
    box-shadow: unset;
  }
}
</style>
